import { Experiments } from '@lib/services/experiments/experiments'
import { type TreatmentOrNotAssignedOrNull } from '@lib/services/experiments/types'

import { type ExperimentClient } from './experiment-client'

export interface ExperimentService {
  // Specific experiment and gate methods will be added here as needed
  // Example methods:
  // isExampleFeatureEnabled(): boolean
  getExampleExperimentAssignment(): TreatmentOrNotAssignedOrNull<
    typeof Experiments.ExampleStatsigExperiment
  >
}

export class ExperimentsServiceImpl implements ExperimentService {
  private readonly experimentClient: ExperimentClient

  constructor(experimentClient: ExperimentClient) {
    this.experimentClient = experimentClient
  }

  getExampleExperimentAssignment(): TreatmentOrNotAssignedOrNull<
    typeof Experiments.ExampleStatsigExperiment
  > {
    return this.experimentClient.getTreatment(Experiments.ExampleStatsigExperiment)
  }

  // Specific experiment and gate methods will be added here as needed
  // Example implementations:
  /*
  isExampleFeatureEnabled(): boolean {
    return this.experimentClient.isGateEnabled(Gates.ExampleGate)
  }

  getExampleExperimentAssignment(): TreatmentOrNull<typeof Experiments.ExampleExperiment> {
    return this.experimentClient.getTreatment(Experiments.ExampleExperiment)
  }
  */
}
